module.exports = __webpack_public_path__ + "img/banner.96793684.png";